// File: src/pages/ForgotPasswordPage.jsx
import React, { useState } from 'react';
import { Container, Typography, Box, TextField, Button } from '@mui/material';
import { BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    try {
      // Send the email as a query parameter (since the backend expects it)
      const response = await fetch(
        `${BASE_URL}/auth/forgot-password?email=${encodeURIComponent(email)}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to request password reset.');
      }
      const data = await response.json();
      setMessage(data.message || 'If this email exists in our system, you will receive a password reset link.');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Forgot Password
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4 }}
      >
        <TextField
          label="Enter your email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}
        {message && (
          <Typography variant="body2" color="success.main">
            {message}
          </Typography>
        )}
        <Button variant="contained" color="primary" type="submit">
          Request Reset Token
        </Button>
        <Button variant="text" onClick={() => navigate('/login')}>
          Back to Login
        </Button>
      </Box>
    </Container>
  );
};

export default ForgotPasswordPage;
